"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var ParAffilateEditor = /** @class */ (function (_super) {
    __extends(ParAffilateEditor, _super);
    function ParAffilateEditor(props) {
        return _super.call(this, props) || this;
    }
    ParAffilateEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    description: _item.description,
                    is_deprecated: _item.is_deprecated,
                    is_locked: _item.is_locked,
                    pprogram_identity: _item.identity,
                    pprogram_domain: _item.pprogram_domain,
                    is_subagents: _item.is_subagents,
                    subagents_percent_x100: _item.subagents_percent_x100,
                    new_promo_contacts_email: _item.new_promo_contacts_email,
                    new_promo_contacts_telegram: _item.new_promo_contacts_telegram,
                    pprogram_contacts_email: _item.pprogram_contacts_email,
                    pprogram_contacts_telegram: _item.pprogram_contacts_telegram
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование партнерской программы"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                is_deprecated: false,
                is_locked: false,
                pprogram_identity: "",
                pprogram_domain: "",
                is_subagents: false,
                subagents_percent_x100: 5,
                new_promo_contacts_email: "",
                new_promo_contacts_telegram: "",
                pprogram_contacts_email: "",
                pprogram_contacts_telegram: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание партнерской программы"]);
            });
        }
        this.doReSetRules();
    };
    ParAffilateEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            pprogram_identity_rules: { isError: false },
            pprogram_domain_rules: { isError: false },
            subagents_percent_x100_rules: { isError: false },
        });
    };
    ParAffilateEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название партнерской программы] не заполнено!" } });
            return false;
        }
        if ((!this.state.pprogram_domain) || (this.state.pprogram_domain.length === 0)) {
            this.setState({ pprogram_domain_rules: { isError: true, errorMessage: "Поле [домен партнерской программы] не заполнено!" } });
            return false;
        }
        if ((!this.state.pprogram_identity) || (this.state.pprogram_identity.length === 0)) {
            this.setState({ pprogram_identity_rules: { isError: true, errorMessage: "Поле [идентификатор партнерской программы] не заполнено!" } });
            return false;
        }
        if (this.state.is_subagents) {
            if ((!this.state.subagents_percent_x100) || (this.state.subagents_percent_x100 <= 0) || (this.state.subagents_percent_x100 >= 99)) {
                this.setState({ subagents_percent_x100_rules: { isError: true, errorMessage: "Поле [Процент отчисления субагентам] не заполнено!" } });
                return false;
            }
        }
        return true;
    };
    ParAffilateEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditGws({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                is_locked: this.state.is_locked,
                is_deprecated: this.state.is_deprecated,
                pprogram_domain: this.state.pprogram_domain,
                is_subagents: this.state.is_subagents,
                subagents_percent_x100: this.state.subagents_percent_x100,
                new_promo_contacts_email: this.state.new_promo_contacts_email,
                new_promo_contacts_telegram: this.state.new_promo_contacts_telegram,
                pprogram_contacts_email: this.state.pprogram_contacts_email,
                pprogram_contacts_telegram: this.state.pprogram_contacts_telegram,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Партнерская программа изменена!");
            });
        }
    };
    ParAffilateEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddGws({
                description: this.state.description,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                is_locked: this.state.is_locked,
                identity: this.state.pprogram_identity,
                pprogram_domain: this.state.pprogram_domain,
                is_subagents: this.state.is_subagents,
                subagents_percent_x100: this.state.subagents_percent_x100,
                new_promo_contacts_email: this.state.new_promo_contacts_email,
                new_promo_contacts_telegram: this.state.new_promo_contacts_telegram,
                pprogram_contacts_email: this.state.pprogram_contacts_email,
                pprogram_contacts_telegram: this.state.pprogram_contacts_telegram,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Партнерская программа создана!");
            });
        }
    };
    ParAffilateEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    ParAffilateEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая партнерская программа";
        }
        else {
            return "Изменить партнерскую программу";
        }
    };
    ParAffilateEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 770 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Идентификатор:", placeholder: "Введите идентификатор партнерской программы" }, value: this.state.pprogram_identity, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_identity: newVal,
                        pprogram_identity_rules: { isError: false }
                    });
                }, required: true, disabled: this.props.record !== null, rules: this.state.pprogram_identity_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Домен:", placeholder: "Введите домен партнерской программы" }, value: this.state.pprogram_domain, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_domain: newVal,
                        pprogram_domain_rules: { isError: false }
                    });
                }, required: true, rules: this.state.pprogram_domain_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устаревшиая партнерская программа", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокированная партнерская программа", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешить суб-аффилейтов", value: this.state.is_subagents, onChecked: function (checked) { _this.setState({ is_subagents: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Комиссия субаффилейтов", placeholder: "Введите % комиссии" }, values: { max: 99, min: 1, value: this.state.subagents_percent_x100 }, onValueChanged: function (newVal) {
                    _this.setState({
                        subagents_percent_x100: newVal,
                        subagents_percent_x100_rules: { isError: false }
                    });
                }, required: this.state.is_subagents, disabled: !this.state.is_subagents, rules: this.state.subagents_percent_x100_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "EMail для контактов:", placeholder: "Введите EMail" }, value: this.state.pprogram_contacts_email, onValueChanged: function (newVal) { _this.setState({ pprogram_contacts_email: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Telegram для контактов:", placeholder: "Введите Telegram" }, value: this.state.pprogram_contacts_telegram, onValueChanged: function (newVal) { _this.setState({ pprogram_contacts_telegram: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "EMail для запроса промо:", placeholder: "Введите EMail" }, value: this.state.new_promo_contacts_email, onValueChanged: function (newVal) { _this.setState({ new_promo_contacts_email: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Telegram для запроса промо:", placeholder: "Введите Telegram" }, value: this.state.new_promo_contacts_telegram, onValueChanged: function (newVal) { _this.setState({ new_promo_contacts_telegram: newVal }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return ParAffilateEditor;
}(React.Component));
exports.default = ParAffilateEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/AffilateEditor.tsx
// module id = 2011
// module chunks = 0